export const GetAllAvailableReports = async (user, location) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify({ user, location }),
        };

        const response = await fetch(`${ApiURL}Metabase`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            return { success: true, data: responseData.data };
        } else {
            return { success: false, data: [] };
        }
    } catch (error) {
        console.error("GetAllAvailableReports error:", error);
        return { success: false, data: [] };
    }
};